import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import axiosInstance from 'src/utils/axios';

export interface UpdatePoLineItemRequest {
  supplierId: number;
  poId: number;
  lineItemNumber: number;
  lineItemApproval: number;
  quantity: number;
  itemNumber: string;
  previousItemNumber: string;
  itemDescription: string;
  glCode: string;
  price: number;
  weight: number;
  uom: string;
  productId: number;
  catalogId: number;
  categoryId: number;
}

interface UseUpdatePoLineItemMutationOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

const useUpdatePoLineItemMutation = ({
  onSuccess,
  onError,
}: UseUpdatePoLineItemMutationOptions = {}) => {
  const mutation = useMutation({
    mutationFn: async (request: UpdatePoLineItemRequest) => {
      await axiosInstance.put(api.updatePoLineItem, request);
      return;
    },
    onSuccess: (data, variables) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useUpdatePoLineItemMutation;
